/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_Getting_ProxyInputs */



/**
* | output |
* | --- |
* | "Getting proxy information..." |
*
* @param {Iconik_Proxy_Status_Getting_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_getting_proxy = /** @type {((inputs?: Iconik_Proxy_Status_Getting_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_Getting_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recuperation des informations du proxy...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy-Informationen abrufen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ottenimento delle informazioni sul proxy...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получение информации о прокси-сервере...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Obteniendo información del proxy...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在获取代理信息……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシ情報を取得しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी जानकारी प्राप्त की जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Obtendo informações de proxy...")
	return /** @type {LocalizedString} */ ("Getting proxy information...")
});